<template>
    <VJoyTextarea
        v-if="profileQualificationStore.inEditMode"
        v-model="profileQualificationStore.qualificationUpdateForm.comatchLegacyNotes"
        autogrow
        data-testid="vetting-comatch-legacy-notes-edition"
    ></VJoyTextarea>
    <TextField v-else :content="profileQualificationStore.qualificationUpdateForm.comatchLegacyNotes" data-testid="vetting-comatch-legacy-notes" />
</template>

<script setup lang="ts">
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';

    const profileQualificationStore = useProfileQualificationStore();
</script>
